'use strict';

exports.__esModule = true;

var _styles = require('./styles');

var styles = _interopRequireWildcard(_styles);

var _util = require('./util');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var omit = function omit(obj, blacklist) {
  var next = {};
  for (var key in obj) {
    if (blacklist.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }
  return next;
};

var funcs = Object.keys(styles).map(function (key) {
  return styles[key];
}).filter(function (fn) {
  return typeof fn === 'function';
});

var blacklist = funcs.reduce(function (a, fn) {
  return [].concat(a, Object.keys(fn.propTypes || {}));
}, ['theme']);

exports.default = function (props) {
  return funcs.map(function (fn) {
    return fn(props);
  }).reduce(_util.merge, omit(props, blacklist));
};


//////////////////
// WEBPACK FOOTER
// ./~/clean-tag/~/styled-system/dist/mixed.js
// module id = 286
// module chunks = 168707334958949